import { render, staticRenderFns } from "./FilteredByRelated.vue?vue&type=template&id=0791109d&"
import script from "./FilteredByRelated.vue?vue&type=script&lang=js&"
export * from "./FilteredByRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports